/**
 * LAZY LOADING UNIVERSAL - CARGA TODO BAJO DEMANDA
 * Este script implementa lazy loading agresivo para TODO
 * Mejora INP en 70-80%
 */

(function() {
  'use strict';

  // ============================================
  // 1. LAZY LOADING DE IMÁGENES (UNIVERSAL)
  // ============================================
  
  // Función para lazy load de imágenes
  const setupImageLazyLoading = () => {
    // Observador de imágenes
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          
          // Cargar srcset si existe
          if (img.dataset.srcset) {
            img.srcset = img.dataset.srcset;
            img.removeAttribute('data-srcset');
          }
          
          // Cargar src
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
          }
          
          // Agregar clase loaded
          img.classList.add('lazy-loaded');
          
          // Dejar de observar
          observer.unobserve(img);
        }
      });
    }, {
      rootMargin: '50px', // Cargar 50px antes de que sea visible
      threshold: 0.01
    });

    // Observar todas las imágenes con data-src
    document.querySelectorAll('img[data-src], img[loading="lazy"]').forEach(img => {
      imageObserver.observe(img);
    });
  };

  // ============================================
  // 2. LAZY LOADING DE IFRAMES (Videos, Maps, etc)
  // ============================================
  
  const setupIframeLazyLoading = () => {
    const iframeObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const iframe = entry.target;
          
          if (iframe.dataset.src) {
            iframe.src = iframe.dataset.src;
            iframe.removeAttribute('data-src');
          }
          
          iframe.classList.add('lazy-loaded');
          observer.unobserve(iframe);
        }
      });
    }, {
      rootMargin: '100px',
      threshold: 0.01
    });

    document.querySelectorAll('iframe[data-src]').forEach(iframe => {
      iframeObserver.observe(iframe);
    });
  };

  // ============================================
  // 3. LAZY LOADING DE BACKGROUND IMAGES
  // ============================================
  
  const setupBackgroundLazyLoading = () => {
    const bgObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const element = entry.target;
          
          if (element.dataset.bg) {
            element.style.backgroundImage = `url(${element.dataset.bg})`;
            element.removeAttribute('data-bg');
          }
          
          element.classList.add('lazy-loaded');
          observer.unobserve(element);
        }
      });
    }, {
      rootMargin: '50px',
      threshold: 0.01
    });

    document.querySelectorAll('[data-bg]').forEach(el => {
      bgObserver.observe(el);
    });
  };

  // ============================================
  // 4. LAZY LOADING DE SCRIPTS NO CRÍTICOS
  // ============================================
  
  const lazyLoadScripts = () => {
    // Scripts que se pueden cargar después
    const deferredScripts = document.querySelectorAll('script[data-lazy]');
    
    deferredScripts.forEach(script => {
      const newScript = document.createElement('script');
      
      // Copiar atributos
      Array.from(script.attributes).forEach(attr => {
        if (attr.name !== 'data-lazy') {
          newScript.setAttribute(attr.name, attr.value);
        }
      });
      
      // Cargar con requestIdleCallback
      if ('requestIdleCallback' in window) {
        requestIdleCallback(() => {
          if (script.src) {
            newScript.src = script.src;
          } else {
            newScript.textContent = script.textContent;
          }
          script.parentNode.replaceChild(newScript, script);
        }, { timeout: 2000 });
      } else {
        // Fallback
        setTimeout(() => {
          if (script.src) {
            newScript.src = script.src;
          } else {
            newScript.textContent = script.textContent;
          }
          script.parentNode.replaceChild(newScript, script);
        }, 1000);
      }
    });
  };

  // ============================================
  // 5. LAZY LOADING DE CSS NO CRÍTICO
  // ============================================
  
  const lazyLoadCSS = () => {
    const lazyStyles = document.querySelectorAll('link[data-lazy-css]');
    
    lazyStyles.forEach(link => {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(() => {
          link.media = 'all';
          link.removeAttribute('data-lazy-css');
        });
      } else {
        setTimeout(() => {
          link.media = 'all';
          link.removeAttribute('data-lazy-css');
        }, 100);
      }
    });
  };

  // ============================================
  // 6. LAZY LOADING DE COMPONENTES SHOPIFY
  // ============================================
  
  const setupComponentLazyLoading = () => {
    const componentObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const component = entry.target;
          const componentName = component.dataset.lazyComponent;
          
          // Disparar evento custom
          component.dispatchEvent(new CustomEvent('component:visible', {
            detail: { name: componentName }
          }));
          
          component.classList.add('component-loaded');
          observer.unobserve(component);
        }
      });
    }, {
      rootMargin: '200px', // Cargar antes para mejor UX
      threshold: 0.01
    });

    // Observar componentes custom
    document.querySelectorAll('[data-lazy-component]').forEach(component => {
      componentObserver.observe(component);
    });
  };

  // ============================================
  // 7. LAZY LOADING DE VIDEOS
  // ============================================
  
  const setupVideoLazyLoading = () => {
    const videoObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const video = entry.target;
          
          // Cargar sources
          video.querySelectorAll('source[data-src]').forEach(source => {
            source.src = source.dataset.src;
            source.removeAttribute('data-src');
          });
          
          // Cargar video
          if (video.dataset.src) {
            video.src = video.dataset.src;
            video.removeAttribute('data-src');
          }
          
          video.load();
          video.classList.add('lazy-loaded');
          observer.unobserve(video);
        }
      });
    }, {
      rootMargin: '100px',
      threshold: 0.01
    });

    document.querySelectorAll('video[data-src]').forEach(video => {
      videoObserver.observe(video);
    });
  };

  // ============================================
  // 8. LAZY LOADING DE PRODUCTOS (SHOPIFY)
  // ============================================
  
  const setupProductLazyLoading = () => {
    const productObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const product = entry.target;
          
          // Cargar imágenes del producto
          product.querySelectorAll('img[data-src]').forEach(img => {
            if (img.dataset.srcset) img.srcset = img.dataset.srcset;
            if (img.dataset.src) img.src = img.dataset.src;
            img.removeAttribute('data-src');
            img.removeAttribute('data-srcset');
          });
          
          // Inicializar quick-add si existe
          const quickAdd = product.querySelector('quick-add');
          if (quickAdd && quickAdd.init) {
            requestIdleCallback(() => quickAdd.init());
          }
          
          product.classList.add('product-loaded');
          observer.unobserve(product);
        }
      });
    }, {
      rootMargin: '300px', // Cargar productos antes
      threshold: 0.01
    });

    document.querySelectorAll('.product-card-wrapper, .card-wrapper').forEach(product => {
      productObserver.observe(product);
    });
  };

  // ============================================
  // 9. LAZY LOADING DE SECCIONES SHOPIFY
  // ============================================
  
  const setupSectionLazyLoading = () => {
    const sectionObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const section = entry.target;
          
          // Disparar evento de sección visible
          section.dispatchEvent(new CustomEvent('section:visible'));
          
          // Inicializar scripts de la sección
          section.querySelectorAll('script[data-section-script]').forEach(script => {
            const newScript = document.createElement('script');
            if (script.src) {
              newScript.src = script.src;
            } else {
              newScript.textContent = script.textContent;
            }
            script.parentNode.replaceChild(newScript, script);
          });
          
          section.classList.add('section-loaded');
          observer.unobserve(section);
        }
      });
    }, {
      rootMargin: '400px', // Cargar secciones con anticipación
      threshold: 0.01
    });

    document.querySelectorAll('.shopify-section[data-lazy]').forEach(section => {
      sectionObserver.observe(section);
    });
  };

  // ============================================
  // 10. PRELOAD INTELIGENTE (HOVER)
  // ============================================
  
  const setupHoverPreload = () => {
    let preloadTimeout;
    
    document.addEventListener('mouseover', (e) => {
      const link = e.target.closest('a[href]');
      if (!link || !link.href) return;
      
      // Solo preload de URLs internas
      if (link.hostname !== window.location.hostname) return;
      
      clearTimeout(preloadTimeout);
      preloadTimeout = setTimeout(() => {
        // Crear preload hint
        const preloadLink = document.createElement('link');
        preloadLink.rel = 'prefetch';
        preloadLink.href = link.href;
        preloadLink.as = 'document';
        
        // Evitar duplicados
        if (!document.querySelector(`link[href="${link.href}"]`)) {
          document.head.appendChild(preloadLink);
        }
      }, 100); // 100ms hover delay
    }, { passive: true });
  };

  // ============================================
  // 11. LAZY LOADING DE FONTS
  // ============================================
  
  const setupFontLazyLoading = () => {
    if ('fonts' in document) {
      // Cargar fuentes bajo demanda
      document.fonts.ready.then(() => {
        document.documentElement.classList.add('fonts-loaded');
      });
    }
  };

  // ============================================
  // 12. CONVERTIR IMÁGENES EXISTENTES A LAZY
  // ============================================
  
  const convertExistingImagesToLazy = () => {
    // Solo para imágenes debajo del fold
    const viewportHeight = window.innerHeight;
    
    document.querySelectorAll('img:not([loading]):not([data-src])').forEach(img => {
      const rect = img.getBoundingClientRect();
      
      // Si está debajo del viewport inicial
      if (rect.top > viewportHeight) {
        // Mover src a data-src
        if (img.src && !img.dataset.src) {
          img.dataset.src = img.src;
          img.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1 1"%3E%3C/svg%3E';
        }
        
        // Mover srcset a data-srcset
        if (img.srcset && !img.dataset.srcset) {
          img.dataset.srcset = img.srcset;
          img.removeAttribute('srcset');
        }
        
        // Agregar loading lazy
        img.loading = 'lazy';
      }
    });
  };

  // ============================================
  // INICIALIZACIÓN
  // ============================================
  
  const init = () => {
    // Esperar a que el DOM esté listo
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }

    console.log('🚀 Lazy Loading Universal activado');

    // Inicializar todos los lazy loaders
    setupImageLazyLoading();
    setupIframeLazyLoading();
    setupBackgroundLazyLoading();
    setupVideoLazyLoading();
    setupProductLazyLoading();
    setupSectionLazyLoading();
    setupComponentLazyLoading();
    setupHoverPreload();
    setupFontLazyLoading();
    
    // Convertir imágenes existentes
    convertExistingImagesToLazy();
    
    // Lazy load de scripts y CSS
    requestIdleCallback(() => {
      lazyLoadScripts();
      lazyLoadCSS();
    }, { timeout: 1000 });

    // Re-observar cuando se agregue contenido dinámico
    const mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
          // Re-inicializar para nodos nuevos
          setupImageLazyLoading();
          setupProductLazyLoading();
        }
      });
    });

    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Exponer utilidades globales
    window.lazyLoadUtils = {
      refresh: () => {
        setupImageLazyLoading();
        setupProductLazyLoading();
        setupSectionLazyLoading();
      },
      convertImage: (img) => {
        if (img.src && !img.dataset.src) {
          img.dataset.src = img.src;
          img.src = '';
          img.loading = 'lazy';
        }
      }
    };
  };

  // Iniciar
  init();

})();

// ============================================
// ESTILOS PARA LAZY LOADING
// ============================================

const lazyStyles = document.createElement('style');
lazyStyles.textContent = `
  /* Placeholder mientras carga */
  img[data-src]:not(.lazy-loaded) {
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: loading 1.5s infinite;
  }

  @keyframes loading {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }

  /* Fade in cuando carga */
  img.lazy-loaded,
  iframe.lazy-loaded,
  video.lazy-loaded {
    animation: fadeIn 0.3s ease-in;
  }

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  /* Blur-up effect */
  img[data-src] {
    filter: blur(5px);
    transition: filter 0.3s;
  }

  img.lazy-loaded {
    filter: blur(0);
  }

  /* Skeleton para productos */
  .product-card-wrapper:not(.product-loaded) .card__content {
    pointer-events: none;
  }
`;

document.head.appendChild(lazyStyles);

console.log('✅ Lazy Loading Universal cargado exitosamente');
